(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sticky = document.querySelector('.header-sticky--smart');

    if (!sticky) {
      return;
    }

    const previousSiblings = (elem) => {
      let siblings = [];

      while ((elem = elem.previousElementSibling)) {
        siblings.push(elem);
      }
      return siblings;
    };

    const siblings = previousSiblings(document.querySelector('.section-header'));

    let offset = 0;
    const elements = siblings.forEach((element) => {
      offset += element.offsetHeight;
    });

    const options = {
      tolerance: 5,
      offset: offset,
    };

    const headroom = new Headroom(sticky, options);
    headroom.init();
  });

  if (document.getElementById('search-modal')) {
    document.getElementById('search-modal').addEventListener('open', function (e) {
      setTimeout(function () {
        e.target.querySelector('input[name="q"]').focus();
      }, 100);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
